import React from 'react';
import styled from 'styled-components';
import { palette } from './colors';
import MuiFileCopy from '@mui/icons-material/FileCopy';
import MuiEdit from '@mui/icons-material/Edit';
import MuiDelete from '@mui/icons-material/Delete';
import MuiOpenInNew from '@mui/icons-material/OpenInNew';
import MoreIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { DarkArrowTooltip } from '../tooltips/DarkArrowTooltip';
import { StyledIconButton } from './miscellaneous';



export const SmallFileCopy = styled(MuiFileCopy)`
    font-size: 1em !important;
`;

export const SmallEdit = styled(MuiEdit)`
    font-size: 1em !important;
`;

export const SmallDelete = styled(MuiDelete)`
    font-size: 1em !important;
`;

export const PrimaryOpenInNew = styled(MuiOpenInNew)`
    color: ${palette.evergreen.aspargus};
`;

export const DarkArrowTooltipIcon = ({
    row,
    customFunction,
    title,
    icon,
}) => {
    const ariaLabel = `${title}-icon`
    let isMoreIcon = false;

    const iconComponent = (() => {
        switch (icon) {
            case 'delete':
                return <DeleteIcon/>
            case 'edit':
                return <EditIcon/>
            case 'more':
                isMoreIcon = true;
                return <MoreIcon/>
            default:
                return icon;
        }
    })();

    return (
        <DarkArrowTooltip
            onClick={(e) => e.preventDefault()}
            title={title}
            arrow
            placement="top"
        >
            <StyledIconButton
                aria-controls={isMoreIcon ? "simple-menu" : undefined}
                aria-haspopup={isMoreIcon ? "true" : "false"}
                aria-label={ariaLabel}
                onClick={(e) => {
                    e.preventDefault();
                    customFunction(e, row);
                }}
                id={row.id}
            >
                {iconComponent}
            </StyledIconButton>
        </DarkArrowTooltip>
    );
};
